import type { CatalogRepository } from '@/domain/port/CatalogRepository';
import type { Category } from '@/domain/model/Category';
import type { Subcategory } from '@/domain/model/Subcategory';
import type { Chapter } from '@/domain/model/Chapter';

export class CatalogService {
  private readonly catalogRepository: CatalogRepository;

  constructor(catalogRepository: CatalogRepository) {
    this.catalogRepository = catalogRepository;
  }

  async getCategories(): Promise<Category[]> {
    return this.catalogRepository.getCategories();
  }

  async getCategory(id: string): Promise<Category> {
    return this.catalogRepository.getCategory(id);
  }

  async getSubcategory(id: string): Promise<Subcategory> {
    return this.catalogRepository.getSubcategory(id);
  }

  async getChaptersBySubcategory(subcategoryId: string): Promise<Chapter[]> {
    return this.catalogRepository.getChaptersBySubcategory(subcategoryId);
  }
}
